import { IAddress } from './address.interface';
import { SwiftCardState } from './swift-card-state.enum';

export interface ISwiftCardInfoDetails {
  cardNumber: string;
  activationDate?: Date;
  newCardDeliveryAddress: IAddress;
  swiftCardState?: SwiftCardState;
  verified?: boolean;
  photo?: Blob;
}
